import React, { useEffect, useState, useRef } from "react";
import { Menu, Transition } from "@headlessui/react";
import { usePopper } from "react-popper";
import { bottom } from "@popperjs/core";
import Image from "../components/elements/Image";
import { Link, useNavigate } from "react-router-dom";
import Button from "../components/form/Button";
import LogoutPopup from "../components/LogoutPopup";

import { useSelector } from "react-redux";
import { API_URL } from "../config/host";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { authLogout } from "../store/authSlice";
import { postData } from "../services/api";
import TwoFASettingsPopup from "../components/popup/TwoFASettingsPopup";

const UserDropdown = ({ xPlacement, ...props }) => {
  const { t } = useTranslation();
  const role = localStorage.getItem("role");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const user = useSelector((state) => state.auth?.user);
  const popperElRef = useRef(null);
  const [targetElement, setTargetElement] = useState(null);
  const [popperElement, setPopperElement] = useState(null);

  const [displayImage, setDisplayImage] = useState("");
  const [displayName, setDisplayName] = useState("");
  const [enabledLogoutPopup, setenabledLogoutPopup] = useState(false);
  const [enabledtwoFAPopup, setenabledTwoFAPopup] = useState(false);
  const placements = {
    left: "bottom-start",
    right: "bottom-end",
    "": bottom,
  };

  const { styles, attributes } = usePopper(targetElement, popperElement, {
    placement: placements[xPlacement],
    modifiers: [
      {
        name: "offset",
        options: {
          offset: [0, 8],
        },
      },
    ],
  });

  const handleTwoFASettings = () => {
    setenabledTwoFAPopup(true);
  };

  const handleLogout = () => {
    setenabledLogoutPopup(true); 
  };

  let dropdownData = [];
  const createMenuItem = (id, label, icon, link, type = "link", standout = false, func = null) => ({
    _id: id,
    label: t(label),
    icon,
    link,
    type,
    standout,
    func, // Add dynamic function for handling button clicks
  });

  if (role && role !== "master-admin") {
    dropdownData = [
      ...(user?.isInvitedEmployee !== 2 && role !== "customer-boardmember" && role !== "customer-executive"
        ? [createMenuItem(1, "profile", "fa-circle-user", "/profile")]
        : []),
      ...(user?.isInvitedEmployee !== 2
        ? [createMenuItem(2, "change_password", "fa-key", "/change-password")]
        : []),
      ...(role === "customer-admin" || role === "customer-subadmin"
        ? [createMenuItem(4, "competencies", "fa-circle-waveform-lines", "/competencies-alt")]
        : []),
      ...(role === "customer-admin" || role === "customer-subadmin"
        ? [createMenuItem(5, "Billing", "fa-money-simple-from-bracket", "/billing")]
        : []),
      // ...(role === "customer-admin" || role === "customer-subadmin"
      //   ? [createMenuItem(9, "twofa_settings", "fa-shield-check", "/","button",false,handleTwoFASettings)]
      //   : []),
      createMenuItem(10, "logout", "fa-arrow-right-from-arc", "/","button", true,handleLogout), // `standout` is always true here
    ];
  } else {
    dropdownData = [
      createMenuItem(1, "profile", "fa-circle-user", "/profile"),
      createMenuItem(2, "change_password", "fa-key", "/change-password"),
      createMenuItem(10, "logout", "fa-arrow-right-from-arc", "/","button", true,handleLogout), // `standout` is always true here
    ];
  }

  useEffect(() => {
    if (role === "content-manager") {
      setDisplayName(user?.name);
    } else {
      setDisplayName(user?.company_name);
    }
    setDisplayImage(API_URL + user?.image);
  }, [user,role]);

  useEffect(() => {
    if (user && user?.status === 2) {
      dispatch(authLogout());
      localStorage.removeItem("accessToken");
      localStorage.removeItem("loginAs");
      localStorage.removeItem("role");
      localStorage.removeItem("isTrial");

      localStorage.removeItem("reminderId");
      localStorage.removeItem("reminderDate");
      localStorage.removeItem("reminderFiled");
      return navigate("/");
    } else {
      async function profileData() {
        try {
          const result = await postData("profile/details", {});
          if (result?.data) {
            if (result?.data?.status === 2) {
              dispatch(authLogout());
              localStorage.removeItem("accessToken");
              localStorage.removeItem("loginAs");
              localStorage.removeItem("role");
              localStorage.removeItem("isTrial");

              localStorage.removeItem("reminderId");
              localStorage.removeItem("reminderDate");
              localStorage.removeItem("reminderFiled");
              return navigate("/");
            }
          } else {
            console.log("Profile Details message", result.message);
          }
        } catch (error) {
          console.log("Error profile details catch", error.message);
        }
      }
      profileData();
    }
  }, [user, dispatch, navigate]);

  return (
    <>
      <Menu as="div">
        {({ open }) => (
          <>
            <Menu.Button ref={setTargetElement} className="flex items-center">
              <div className="relative w-full h-10 flex items-center justify-center focus:ring-0 transition-all duration-200">
                <div className="w-8 h-8 min-w-[32px] overflow-hidden rounded-full">
                  <Image
                    src={displayImage}
                    alt={"Admin"}
                    width={"100%"}
                    height={"100%"}
                    effect={"blur"}
                    classes={"object-cover"}
                    id={"headerImg"}
                  />
                </div>
                <div className="text-sm font-semibold text-slate-500 mx-2">
                  {displayName}
                  {role !== "content-manager" ? (
                    <small className="block text-xs text-slate-400">{user?.name}</small>
                  ) : (
                    ""
                  )}
                </div>
                <div className="text-xs text-slate-400">
                  <i className={"fa-light fa-fw " + (open ? "fa-chevron-up" : "fa-chevron-down")}></i>
                </div>
              </div>
            </Menu.Button>
            <Transition
              show={open}
              leave="transition duration-75"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
              className="z-50"
              beforeEnter={() => setPopperElement(popperElRef.current)}
              afterLeave={() => setPopperElement(null)}
              ref={popperElRef}
              style={styles.popper}
              {...attributes.popper}
            >
              <Menu.Items className="w-48 origin-top-right bg-white border-0 divide-y divide-slate-100 rounded-md shadow ring-0">
                <div className="py-1 max-h-80 divide-y divide-slate-100 overflow-auto scroll-smooth scrollbar">
                  {dropdownData.map((item, index) => (
                    <Menu.Item key={index} as="div">
                      {({ close }) => (
                        <>
                          {item.type === "link" && (
                            <Link
                              to={item.link}
                              className="flex items-center py-2 px-3 gap-3 text-slate-500 font-medium hover:bg-teal-500 hover:text-white transition-all duration-200"
                              onClick={close}
                            >
                              <div className="w-5 h-5 flex items-center justify-center text-base">
                                <i className={"fa-regular fa-fw " + item.icon}></i>
                              </div>
                              <div className="text-xs">{item.label}</div>
                            </Link>
                          )}
                          {item.type === "button" && (
                            <Button
                              buttonLabel={item.label}
                              //buttonClasses={`!w-full !flex !items-center !justify-start !py-2 !px-3 !gap-3 !text-rose-500 !rounded-none !text-base !font-medium !bg-white hover:!bg-teal-500 hover:!text-white !transition-all !duration-200`}
                               buttonClasses={`!w-full !flex !items-center !justify-start !py-2 !px-3 !gap-3 !text-base !font-medium !rounded-none !transition-all !duration-200 !bg-white ${
                                item.standout
                                  ? "!text-rose-500 hover:!bg-rose-500 hover:!text-white"
                                  : "!text-slate-600 hover:!bg-slate-100"
                              }`}
                              buttonType="button"
                              buttonIcon={"fa-regular "+item.icon}                              
                              buttonIconPosition="left"
                              buttonHasLink={false}
                              buttonLabelClasses="!text-xs !font-semibold"
                              functions={() => {
                                item.func(); // Call the dynamic function (either handleLogout or handleTwoFASettings)
                                close(); // Close the dropdown after clicking
                              }}
                            />
                          )}
                        </>
                      )}
                    </Menu.Item>
                  ))}
                </div>
              </Menu.Items>
            </Transition>
          </>
        )}
      </Menu>
      {enabledLogoutPopup && (
        <LogoutPopup
          isOpen={enabledLogoutPopup}
          setIsOpen={(val) => setenabledLogoutPopup(val)}
        />
      )}
      {enabledtwoFAPopup && (
        <TwoFASettingsPopup
          isOpen={enabledtwoFAPopup}
          setIsOpen={(val) => setenabledTwoFAPopup(val)}
        />
      )}
    </>
  );
};

export default UserDropdown;
